export { default as NotImplemented } from './src/not-implemented';
